import React from 'react';

import { SectionOneMobile, SectionTwoMobile, SectionThreeMobile } from './sections/_module';

function StoryMobile() {
  return (
    <React.Fragment>
      <SectionOneMobile />
      <SectionTwoMobile />
      <SectionThreeMobile />
    </React.Fragment>
  );
}

export default StoryMobile;
